// Espelha VendaTipoDocumentoEnum no backend (lookup venda_tipo_documento).
// venda e UMA entidade para os tres tipos; a conversao Orcamento -> Pedido troca este campo
// no MESMO registro, nao cria um segundo documento.
export enum VendaTipoDocumentoEnum {
    Orcamento = 1,
    PedidoDeVenda = 2,
    Modelo = 3,
}
